(function($) {

    var loaded = false;

    $(document).on("zp-ready", function () {
        zp_init();
    });

    function zp_init()  {
        //zp_unload();

        var accordion = $(".zp_accordion");
        if(accordion.length > 0) {
            accordion.each(function (index, element) {
                var ele = $(element);
                if (!ele.hasClass("zp-loaded")) {
                    ele.addClass("zp-loaded");
                    var data = JSON.parse(ele.attr("data-accordion"));

                    let link = ele.find("> .zp_accordion_element > .heading > .title > .title-link");
                    link.on("click", zp_click);

                    let items = ele.find("> .zp_accordion_element");
                    items.each(function (index, item) {
                        let _item = $(item);
                        // _item.on("mousemove", );
                        zp_show_tooltip(item)
                    });

                    if(!data.collapsibleAll) {
                        ele.find("> .zp_accordion_element > .heading > .title > .title-link").attr("data-parent", "#" + ele.attr("id"));
                    }
                }
                if (ele.find(".zp_accordion_element.active").length <= 0) {
                    ele.removeClass("one-open");
                } else {
                    ele.addClass("one-open");
                }
            });
        }
        if(!loaded) {
            loaded = true;
            $(document).on("zp-unload", zp_unload);
        }
    }

    function zp_click(e) {
        e.preventDefault();
        var _this = $(this);
        var accordion = _this.closest(".zp_accordion");
        var data = JSON.parse(accordion.attr("data-accordion"));
        setTimeout(function() {
            accordion.find("> .zp_accordion_element > .heading > .title > .title-link").each(function(index, element) {
                var ele = $(element);
                var container = ele.closest(".zp_accordion_element");
                if(ele.attr("aria-expanded") == "true")
                {
                    container.addClass("active");
                }
                else
                {
                    container.removeClass("active");
                }
            });
            if(accordion.find(".zp_accordion_element.active").length <= 0) {
                accordion.removeClass("one-open");
            } else {
                accordion.addClass("one-open");
            }
        }, 1);
        if(data.alwaysOpen) {
            if(_this.closest(".zp_accordion_element").find("> .panel-collapse").hasClass("in")) {
                e.stopPropagation();
            }
        }
    }

    function zp_show_tooltip(item) {

        let tooltip = $('#'+item.id+' .tooltip');
        console.log(tooltip);

        if (tooltip.length != 0) {

            item.onmousemove = handleMouseMove;
            function handleMouseMove(event) {
                var dot, eventDoc, doc, body, pageX, pageY;

                event = event || window.event; // IE-ism

                // If pageX/Y aren't available and clientX/Y are,
                // calculate pageX/Y - logic taken from jQuery.
                // (This is to support old IE)
                if (event.pageX == null && event.clientX != null) {
                    eventDoc = (event.target && event.target.ownerDocument) || document;
                    doc = eventDoc.documentElement;
                    body = eventDoc.body;

                    event.pageX = event.clientX +
                        (doc && doc.scrollLeft || body && body.scrollLeft || 0) -
                        (doc && doc.clientLeft || body && body.clientLeft || 0);
                    event.pageY = event.clientY +
                        (doc && doc.scrollTop  || body && body.scrollTop  || 0) -
                        (doc && doc.clientTop  || body && body.clientTop  || 0 );
                }

                tooltip.css('display', 'block');
                if (event.clientX <= window.innerWidth/2) {
                    tooltip.css('left',event.clientX+25);
                }
                else {
                    tooltip.css('left',event.clientX-(tooltip.width())-25);
                }

                tooltip.css('top',event.clientY-(tooltip.height()/2));
                // Use event.pageX / event.pageY here
            }


            item.onmouseout = handleMouseOut;
            function handleMouseOut(event) {
                tooltip.css('display', 'none');
            }

        }
    }

    function zp_unload() {
        var accordion = $(".zp_accordion");
        if(accordion.length > 0) {
            accordion.find("> .zp_accordion_element > .heading > .title-link").off();
            //$(document).off("zp-unload", zp_unload);
        }
    }

})(jQuery);
